import * as React from 'react';
import styled from 'styled-components';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { LOGO_HP_1, LOGO_HP_3, TUEV_CERTIFICATION } from 'assets/images/images';
import { Lazy } from 'components/lazy/lazy';
import { Card } from 'antd';
import { shadows } from 'styles/theme';
import { ReviewReferences } from './ReviewReferences';

const PromotionCertifiedContainer = styled.div<{ minDesktop: boolean }>`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 160px;
`;

const CardWrapper = styled(Card)<{
  maxMobileLarge: boolean;
  minTablet: boolean;
  showShadows?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  box-shadow: ${({ minTablet, showShadows }) =>
    minTablet && showShadows ? shadows.shadow1 : 'none'};
`;

export const PromotionCertified: React.FC<{
  imageHeight: string;
  cardWidth: string;
  showShadows?: boolean;
  cardPadding?: string;
  hideTrustpilot?: boolean;
}> = ({ imageHeight, cardWidth, showShadows, cardPadding, hideTrustpilot }) => {
  const { minTablet, maxMobileLarge, minDesktop } = useBreakpoints();

  return (
    <PromotionCertifiedContainer minDesktop={minDesktop}>
      <CardWrapper
        maxMobileLarge={maxMobileLarge}
        minTablet={minTablet}
        showShadows={showShadows}
        style={{ padding: cardPadding, width: cardWidth }}
        bodyStyle={{ padding: '0' }}
      >
        <ImageWrapper>
          <Lazy>
            <img src={LOGO_HP_1} alt="Logo 1" height={imageHeight} loading="lazy" />
          </Lazy>
        </ImageWrapper>
      </CardWrapper>
      <CardWrapper
        maxMobileLarge={maxMobileLarge}
        minTablet={minTablet}
        showShadows={showShadows}
        style={{ padding: cardPadding, width: cardWidth }}
        bodyStyle={{ padding: '0' }}
      >
        <ImageWrapper>
          <Lazy>
            <img src={LOGO_HP_3} alt="Logo 3" height={imageHeight} loading="lazy" />
          </Lazy>
        </ImageWrapper>
      </CardWrapper>
      <CardWrapper
        maxMobileLarge={maxMobileLarge}
        minTablet={minTablet}
        showShadows={showShadows}
        style={{ padding: cardPadding, width: cardWidth }}
        bodyStyle={{ padding: '0' }}
      >
        <ImageWrapper>
          <Lazy>
            <img
              src={TUEV_CERTIFICATION}
              alt="TÜV Certification"
              height={imageHeight}
              loading="lazy"
            />
          </Lazy>
        </ImageWrapper>
      </CardWrapper>
      {!hideTrustpilot && (
        <CardWrapper
          maxMobileLarge={maxMobileLarge}
          minTablet={minTablet}
          showShadows={showShadows}
          style={{ padding: cardPadding, width: cardWidth }}
          bodyStyle={{ padding: '0' }}
        >
          <ReviewReferences />
        </CardWrapper>
      )}
    </PromotionCertifiedContainer>
  );
};
